import { render, staticRenderFns } from "./RequestNewContract.vue?vue&type=template&id=2be6e5b9&"
import script from "./RequestNewContract.vue?vue&type=script&lang=js&"
export * from "./RequestNewContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports